import Navigation from '../../components/utils/Navigation';
import NoDataAvailable from '../../components/utils/NoDataAvailable.vue';
import InvoiceDialog from '../../components/dialogs/ticketing/InvoiceDialog.vue';
import InvoiceView from '../../components/dialogs/ticketing/InvoiceView.vue';
import moment from 'moment';
import { isValid } from '../../utils/utilitiesmodule.js';
import { populateUsefulMaps } from '../../utils/entityMethods/ticket.js';
import { invoiceExportMixin } from '../../mixins/invoiceExport.js';
import { formatMoney } from '../../utils/entityMethods/customer.js';

export default {
    name: "Invoices",
    components: { Navigation, NoDataAvailable, InvoiceDialog, InvoiceView },
    mixins: [invoiceExportMixin],
    data() {
        return {
            invoices: null,
            summary: null,
            clients: null,
            menuInvoice: null,
            menuStyle: { top: "0px", left: "0px" },
            filters: {
                id_customer: "",
                invoiced: "",
                dt_inf: moment().subtract(2, 'months').format("YYYY-MM-DD"),
                dt_sup: moment().format("YYYY-MM-DD"),
                offset: 0,
                limit: 500
            }
        };
    },
    async mounted() {
        if (!this.$root.checkAuth()) return;
        this.$session.setRoomPC(null);
        if (this.$root.socket) this.$root.socket("SETPC", null);

        this.$root.$on("refreshInvoices", this.loadInvoices);
        document.addEventListener('click', this.handleDocumentClick);
        await this.populateUsefulMaps();
        this.clients = Object.values(this.$root.customerMap);
        await this.loadInvoices(false);
    },
    beforeDestroy() {
        this.$root.$off("refreshInvoices", this.loadInvoices);
        document.removeEventListener('click', this.handleDocumentClick);
    },
    methods: {
        populateUsefulMaps,
        formatMoney,

        async loadInvoices(applyFilters) {
            const payload = this.buildCleanFilters();
            this.invoices = await this.$api.getInvoices(payload);

            this.summary = this.buildSummary(this.invoices);
        },
        buildCleanFilters() {
            const out = {};
            for (const f in this.filters) {
                if (!isValid(this.filters[f])) continue;
                out[f] = this.filters[f];
            }
            // Conversione date al formato server (una sola volta, fuori dal loop)
            if (out.dt_inf) out.dt_inf = moment(out.dt_inf).format("YYYYMMDD") + "000000";
            if (out.dt_sup) out.dt_sup = moment(out.dt_sup).format("YYYYMMDD") + "235959";
            return out;
        },

        buildSummary(invoices) {
            return {
                total_invoices: invoices.length,
                total_time: invoices.reduce((sum, r) => sum + (Number(r.total_time) || 0), 0),
                total_amount: invoices.reduce((sum, r) => sum + (Number(r.total_amount) || 0), 0),
                invoiced_count: invoices.filter(r => r.invoiced).length
            };
        },
        formatDate(d) {
            if (!d) return "-";
            return moment.utc(d).format("DD/MM/YYYY HH:mm");
        },
        // input in secondi
        formatHours(seconds) {
            if (seconds == null) return "-";
            const s = Math.floor(Number(seconds));
            if (s === 0) return "0s";
            const h = Math.floor(s / 3600);
            const m = Math.floor((s % 3600) / 60);
            const sec = s % 60;
            if (h > 0) return h + "h" + (m > 0 ? " " + m + "m" : "");
            if (m > 0) return m + "m" + (sec > 0 ? " " + sec + "s" : "");
            return sec + "s";
        },
        formatAmount(v) {
            if (v == null) return "0.00";
            return Number(v).toFixed(2);
        },
        openInvoiceView(invoiceID) {
            this.$api.getInvoice(invoiceID).then(res => {
                if (res) {
                    this.$root.$emit("OPENINVOICEVIEW", res);
                }
            });
        },
        // L'export richiede i ticket+sessioni completi: recupero la fattura intera prima.
        async exportInvoiceRow(invoice, format) {
            const full = await this.$api.getInvoice(invoice.id);
            if (!full) return;
            await this.exportInvoiceAs(full, format);
        },

        // ── MENU AZIONI (fixed, esce dalla tabella per non essere clippato) ──
        toggleMenu(invoice, ev) {
            ev.stopPropagation();
            if (this.menuInvoice && this.menuInvoice.id === invoice.id) {
                this.closeMenu();
                return;
            }
            const rect = ev.currentTarget.getBoundingClientRect();
            const MENU_WIDTH = 200;
            const left = Math.max(8, Math.min(rect.right - MENU_WIDTH, window.innerWidth - MENU_WIDTH - 8));
            this.menuStyle = {
                top: rect.bottom + 4 + "px",
                left: left + "px",
                minWidth: MENU_WIDTH + "px"
            };
            this.menuInvoice = invoice;
        },
        closeMenu() {
            this.menuInvoice = null;
        },
        handleDocumentClick() {
            this.closeMenu();
        },
        async markInvoiced(invoice) {
            const result = await this.$api.markInvoice(invoice.id);
            if (result != null) await this.loadInvoices(false);
        },
        async deleteInvoice(invoice) {
            const dialogId = Math.floor(100000 + Math.random() * 900000).toString();
            const self = this;
            this.$root.$on(dialogId, async ok => {
                if (ok) {
                    const result = await self.$api.deleteInvoice(invoice.id);
                    if (result) await self.loadInvoices(false);
                }
                self.$root.$off(dialogId);
            });
            this.$root.openYesNoDialog(
                dialogId,
                this.$t("Delete invoice"),
                this.$t("deleteConfirmation", { 0: invoice.external_invoice_id || ("#" + invoice.id) })
            );
        },
        async exportServerSide() {
            if (!this.filters.id_customer) {
                this.$root.createToastFunction(this.$t("Please select a customer before exporting"), "alert");
                return;
            }
            const blob = await this.$api.exportBilling(this.buildCleanFilters());
            if (!blob) return;
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "invoices_export_" + moment().format("YYYYMMDD_HHmmss") + ".csv";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
    }
};
